import '../styles/_detailCard.scss';

/** The label above each section of a borrower detail card ("Address:", "TIN:", "Email:", "Broker:", ...). */
export const CardSectionLabel = ({ children }: { children: React.ReactNode }) => {
    return <div className='borrowerSelectorCardSectionLabel'>{children}</div>;
};
